import React from 'react'

const OPCIONES_CAPACIDAD = ["64 GB", "128 GB", "256 GB", "512 GB", "1 TB", "2 TB"]
const OPCIONES_ACCESORIOS = ["Caja original", "Cable original", "Cargador", "Funda", "Auriculares", "Vidrio templado", "Adaptador"]

export default function ModalCelular({ formCelular, setFormCelular, guardar, setModal, editId }) {
  
  // 1. Modificamos el manejador de la condición para aplicar la automatización
  const handleEstadoEsteticoChange = (e) => {
    const nuevoEstado = e.target.value;
    
    setFormCelular(prev => {
      let nuevosAccesorios = [...prev.accesorios];
      let nuevaBateria = prev.bateria;

      // Si pasa a ser Nuevo, forzamos batería 100 y caja original
      if (nuevoEstado === 'Nuevo') {
        nuevaBateria = 100;
        if (!nuevosAccesorios.includes('Caja original')) {
          nuevosAccesorios.push('Caja original');
        }
      }

      return {
        ...prev,
        estado_estetico: nuevoEstado,
        bateria: nuevaBateria,
        accesorios: nuevosAccesorios
      };
    });
  }

  const handleAccesorioToggle = (acc) => {
    // Evitamos que destilden "Caja original" si el equipo es Nuevo
    if (formCelular.estado_estetico === 'Nuevo' && acc === 'Caja original') {
      return; 
    }

    setFormCelular(prev => {
      const tieneAccesorio = prev.accesorios.includes(acc)
      return {
        ...prev,
        accesorios: tieneAccesorio ? prev.accesorios.filter(a => a !== acc) : [...prev.accesorios, acc]
      }
    })
  }

  return (
    <div className="inv-modal-overlay">
      <div className="inv-modal-box">
        <div className="inv-modal-header">
          <h2 className="inv-modal-title">
            {editId ? 'Actualizar Celular' : 'Nuevo Celular'}
          </h2>
          <button onClick={() => setModal(false)} className="inv-modal-close">✕</button>
        </div>
        
        <form onSubmit={guardar} className="inv-modal-form">
          <div className="inv-form-grid">
            <div className="span-2">
              <label className="inv-modal-label">Modelo *</label>
              <input required value={formCelular.modelo} onChange={e => setFormCelular({ ...formCelular, modelo: e.target.value })} placeholder="Ej: iPhone 15 Pro Max" className="inv-modal-input" />
            </div>
            <div>
              <label className="inv-modal-label">Capacidad *</label>
              <select required value={formCelular.capacidad} onChange={e => setFormCelular({ ...formCelular, capacidad: e.target.value })} className="inv-modal-select">
                <option value="">Seleccionar...</option>
                {OPCIONES_CAPACIDAD.map(cap => <option key={cap} value={cap}>{cap}</option>)}
              </select>
            </div>
            <div>
              <label className="inv-modal-label">Color *</label>
              <input required value={formCelular.color} onChange={e => setFormCelular({ ...formCelular, color: e.target.value })} placeholder="Ej: Natural Titanium" className="inv-modal-input" />
            </div>
            <div>
              <label className="inv-modal-label">Precio de Venta *</label>
              <div className="price-input-group">
                <select value={formCelular.moneda} onChange={e => setFormCelular({ ...formCelular, moneda: e.target.value })} className="inv-modal-select price-currency-select">
                  <option value="USD">US$</option>
                  <option value="ARS">ARS$</option>
                </select>
                <input required type="text" value={formCelular.precioInput} onChange={e => {
                  const raw = e.target.value.replace(/\D/g, '');
                  setFormCelular({ ...formCelular, precioInput: raw ? Number(raw).toLocaleString('es-AR') : '' });
                }} placeholder="0" className="inv-modal-input price-amount-input" />
              </div>
            </div>
            <div>
              <label className="inv-modal-label">Condición *</label>
              {/* 2. Reemplazamos el onChange directo por nuestra función personalizada */}
              <select required value={formCelular.estado_estetico} onChange={handleEstadoEsteticoChange} className="inv-modal-select">
                <option value="Nuevo">Nuevo</option>
                <option value="Usado">Usado</option>
                <option value="Reacondicionado">Reacondicionado</option>
              </select>
            </div>
            <div>
              <label className="inv-modal-label">Condición de Batería *</label>
              <div className="input-with-symbol">
                {/* 3. Agregamos disabled dependiendo del estado estético */}
                <input 
                  required 
                  type="number" 
                  min="0" 
                  max="100" 
                  value={formCelular.bateria} 
                  onChange={e => setFormCelular({ ...formCelular, bateria: e.target.value })} 
                  placeholder="100" 
                  className="inv-modal-input has-symbol-right" 
                  disabled={formCelular.estado_estetico === 'Nuevo'}
                  style={formCelular.estado_estetico === 'Nuevo' ? { backgroundColor: '#f3f4f6', cursor: 'not-allowed', color: '#6b7280' } : {}}
                />
                <span className="input-symbol right">%</span>
              </div>
            </div>
            <div>
              <label className="inv-modal-label">Estado de venta *</label>
              <select required value={formCelular.estado_venta} onChange={e => setFormCelular({ ...formCelular, estado_venta: e.target.value })} className="inv-modal-select">
                <option value="disponible">Disponible</option>
                <option value="pendiente">Pendiente</option>
                <option value="vendido">Vendido</option>
              </select>
            </div>
            <div className="span-2" style={{ marginTop: '8px' }}>
              <label className="inv-modal-label">Accesorios Incluidos de Regalo</label>
              <div className="accesorios-grid">
                {OPCIONES_ACCESORIOS.map(acc => {
                  const isNuevoYCaja = formCelular.estado_estetico === 'Nuevo' && acc === 'Caja original';
                  return (
                    <label 
                      key={acc} 
                      className="accesorio-checkbox"
                      style={isNuevoYCaja ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
                    >
                      {/* 4. Bloqueamos el checkbox de la caja si es Nuevo */}
                      <input 
                        type="checkbox" 
                        checked={formCelular.accesorios.includes(acc)} 
                        onChange={() => handleAccesorioToggle(acc)} 
                        disabled={isNuevoYCaja}
                      />
                      <span>{acc}</span>
                    </label>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="inv-modal-actions">
            <button type="button" onClick={() => setModal(false)} className="btn-inv-secondary">Cancelar</button>
            <button type="submit" className="btn-inv-submit">Guardar Cambios</button>
          </div>
        </form>
      </div>
    </div>
  )
}